import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/admin/guard';
import { OrganizationList } from '@/features/admin/organizations/organization-list';

export const Route = createFileRoute('/_app/admin/organizations')({
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'admin.organizations');
  },
  component: OrganizationList,
});
